import React, { useState } from "react";
import "../../style/UpcomingCollectionAll.css";
import { TbLayoutGrid } from "react-icons/tb";
import { AiOutlineUnorderedList } from "react-icons/ai";
import UpcomingListView from "./UpcomingListView";
import UpcomingGridView from "./UpcomingGridView";

function UpcomingCOllectionAll() {
    const [activeUpcomingGrid, setActiveupcominggrid] = useState("grid");

  const datas = [
    {
      mainImg: "image 32.png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
      profileName: "Bubblegoose",
    },
    {
      mainImg: "image 32 (1).png",
      profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
      profileName: "DeGods",
    },
    {
      mainImg: "image 32 (2).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
      profileName: "ApeYachtClub",
    },
    {
      mainImg: "image 32 (3).png",
      profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
      profileName: "Midnight Panthers",
    },
    {
        mainImg: "image11.png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
        profileName: "Bubblegoose",
      },
      {
        mainImg: "hhh.png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
        profileName: "DeGods",
      },
      {
        mainImg: "image 32 (6).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
        profileName: "ApeYachtClub",
      },
      {
        mainImg: "image 32 (7).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
        profileName: "Midnight Panthers",
      },
      {
        mainImg: "image 32 (8).png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
        profileName: "Bubblegoose",
      },
      {
        mainImg: "image 32 (9).png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
        profileName: "DeGods",
      },
      {
        mainImg: "image 32 (10).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
        profileName: "ApeYachtClub",
      },
      {
        mainImg: "image 32 (11).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
        profileName: "Midnight Panthers",
      },
      {
        mainImg: "image 32 (12).png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 9.png",
        profileName: "Bubblegoose",
      },
      {
        mainImg: "image 32 (13).png",
        profileImg: "Screen Shot 2021-12-21 at 12.37 8.png",
        profileName: "DeGods",
      },
      {
        mainImg: "image 32 (14).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 8.png",
        profileName: "ApeYachtClub",
      },
      {
        mainImg: "image 32 (15).png",
        profileImg: "Screen Shot 2021-12-21 at 12.38 9.png",
        profileName: "Midnight Panthers",
      },
  ];
  
  return (
    <div>
      <section>
        <div className="mainContainer pt-sm-5 pt-3">
          <div className="d-flex align-items-center headdrop ForSmallUpcoming">
            <h3 className="dropdownGap">upcoming Collection drops</h3>
            <div className="dropdowns">
              <button
                className="dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                All categories{" "}
                <span>
                  <img src="Vector (9).png" alt="arrow" className="mb-2" />
                </span>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <a className="dropdown-item" href="#">
                  All caltegories
                </a>
                <a className="dropdown-item" href="#">
                  Featured Collection
                </a>
                <a className="dropdown-item" href="#">
                  Top artists
                </a>
                <a className="dropdown-item" href="#">
                  recommended Collection
                </a>
                <a className="dropdown-item" href="#">
                  Trending Collection
                </a>
                <a className="dropdown-item" href="#">
                  In game Collection
                </a>
                <a className="dropdown-item" href="#">
                  popular Categories
                </a>
                <a className="dropdown-item" href="#">
                  Traditional
                </a>
                <a className="dropdown-item" href="#">
                  anime / fantacy
                </a>
                <a className="dropdown-item" href="#">
                  character NFT’s
                </a>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between collectionDetailbox mt-sm-4 mt-2">
            <div className="d-flex">
              <div className="filterimg">
                <img src="filter-list 1.png" alt="filter" />
              </div>
              <div className="searchCollection">
                <img src="search (1).png" alt="search" />
                <input
                  type="search"
                  placeholder="Search Collections and Creators"
                />
              </div>
            </div>
            <div className="d-flex ">
              <div className="dropdown ">
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  games{" "}
                  <span>
                    <img
                      src="Vector (10).png"
                      alt="arrow"
                      className="mb-1 ms-3"
                    />
                  </span>
                </button>
                <div
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a className="dropdown-item" href="#">
                    All caltegories
                  </a>
                  <a className="dropdown-item" href="#">
                    Featured Collection
                  </a>
                  <a className="dropdown-item" href="#">
                    Top artists
                  </a>
                  <a className="dropdown-item" href="#">
                    recommended Collection
                  </a>
                </div>
              </div>

              <div className="listGrid">
                <div
                  className={`iconHolder ${
                    activeUpcomingGrid === "grid" ? "listActive" : ""
                  }`}
                  onClick={() => setActiveupcominggrid("grid")}
                >
                  <TbLayoutGrid />
                </div>
                <div
                  className={`iconHolder ${
                    activeUpcomingGrid === "grid" ? "" : "listActive"
                  }`}
                  onClick={() => setActiveupcominggrid("list")}
                >
                  <AiOutlineUnorderedList />
                </div>
              </div>
            </div>
          </div>

          <div className="pt-4">
            {activeUpcomingGrid === "grid" ? (
              <UpcomingGridView datas={datas} />
            ) : (
              <div>
                <UpcomingListView datas={datas} />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default UpcomingCOllectionAll;
